import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { RootStateTypeExtra } from '@store/types'

import { InfoModal } from '@components/modals'

import FirebaseControlQuery from '@firebaseUtil/firebase-control-query'

import { ProjectType } from '@adUtilities/constants/common'

import useGetGeneralExternalLinks from '../hooks/useGetGeneralExternalLinks'

interface GeneralExternalLinkButtonProps {
  hasPanoramicButton?: boolean
}

function GeneralExternalLinkButton({
  hasPanoramicButton,
}: GeneralExternalLinkButtonProps) {
  const { projectIdentity, generalExternalLinkPopup } = useSelector(
    (state: RootStateTypeExtra) => ({
      projectIdentity: state.projectIdentity,
      sessionKey: state.projectIdentity.sessionId,
      generalExternalLinkPopup:
        state.firestore?.session?.building?.generalExternalLinkPopup ||
        state.firestore?.session?.houseAndLand?.generalExternalLinkPopup ||
        false,
    })
  )

  const firebaseControlQuery = FirebaseControlQuery({
    ...projectIdentity,
    sessionKey: projectIdentity.sessionId,
  })

  const [showExternalLink, setShowExternalLink] = useState(false)

  const { generalExternalLink } = useGetGeneralExternalLinks()

  const handleExternalLinkPopup = async () => {
    const generalExternalLinkPopupKey =
      projectIdentity.type === ProjectType.HouseAndLand
        ? 'houseAndLand.generalExternalLinkPopup'
        : 'building.generalExternalLinkPopup'

    await firebaseControlQuery.update({
      [generalExternalLinkPopupKey]: !showExternalLink,
    })
  }

  useEffect(() => {
    setShowExternalLink(generalExternalLinkPopup)
  }, [generalExternalLinkPopup])

  if (!generalExternalLink) {
    return null
  }

  return (
    <>
      <button
        type="button"
        onClick={handleExternalLinkPopup}
        className={`ml-2 truncate rounded-lg border border-mainColour bg-white px-3 py-2 tracking-widest text-mainColour ipad-mini-land:max-w-80 ${hasPanoramicButton ? 'ipad-mini:max-w-24' : 'ipad-mini:max-w-48'}`}
      >
        Ext Link
      </button>

      {showExternalLink && (
        <InfoModal
          isVisible={showExternalLink}
          toggleModal={handleExternalLinkPopup}
          title="General External link selected"
          message="An general external site has been launched. Please use the main Showcase to continue navigating."
        />
      )}
    </>
  )
}

export default GeneralExternalLinkButton
